import { render, staticRenderFns } from "./new.applications.page.vue?vue&type=template&id=55e288cc&"
import script from "./new.applications.page.vue?vue&type=script&lang=js&"
export * from "./new.applications.page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports